import CURRENCIES from '../../data/currencies';
import COUNTRIES from '../../data/countries';
import STOCK_EXCHANGES from '../../data/stockExchanges';

export const INVESTMENT_TYPES = {
  bank_balance: 'Bank Balance',
  fixed_deposit: 'Fixed Deposit',
  mutual_fund: 'Mutual Fund',
  treasury_bill: 'Treasury Bill',
  quoted_stocks: 'Quoted Stocks',
  government_bond: 'Government Bond',
  corporate_bond: 'Corporate Bond',
  private_equity: 'Private Equity',
  convertible: 'Convertible',
  safe: 'SAFE Investment',
  crypto: 'Cryptocurrency',
  real_estate: 'Real Estate (Property)',
  etf: 'ETF',
  gold: 'Gold'
};

export const CURRENCY_OPTIONS = [...CURRENCIES]
  .sort((a, b) => a.name.localeCompare(b.name))
  .map(c => ({
    value: c.code,
    label: `${c.name} (${c.symbol}) - ${c.code}`,
    searchKey: `${c.code} ${c.name} ${c.symbol}`,
  }));

export const COUNTRY_OPTIONS = [...COUNTRIES]
  .sort((a, b) => a.localeCompare(b))
  .map(c => ({
    value: c,
    label: c,
    searchKey: c,
  }));

export const EXCHANGE_OPTIONS = [...STOCK_EXCHANGES]
  .sort((a, b) => a.name.localeCompare(b.name))
  .map(e => ({
    value: e.code,
    label: e.country ? `${e.name} (${e.code}) - ${e.country}` : e.name,
    searchKey: `${e.code} ${e.name} ${e.country}`,
  }));
